const sellingPoints = [
  {
    title: "Proof when it counts",
    description:
      "Timestamped photos tied to each project. When a client disputes work or an insurer asks for documentation, you have it.",
  },
  {
    title: "One place for the team",
    description:
      "Photos from foremen, subs, and office staff land in the same project. No more chasing people for pictures.",
  },
  {
    title: "Find it in seconds",
    description:
      "Search by project, date, or category. Pull up the exact photo without scrolling through weeks of camera roll.",
  },
];

const steps = [
  {
    number: "01",
    title: "Upload",
    description: "Take photos on site and add them to a project.",
  },
  {
    number: "02",
    title: "Organize",
    description: "Sort by project, category, and date.",
  },
  {
    number: "03",
    title: "Find",
    description: "Search and pull up any photo on demand.",
  },
];

export const ImagesFeature = () => {
  return (
    <div className="space-y-16 sm:space-y-20">
      <div className="space-y-10">
        <div className="text-center max-w-2xl mx-auto space-y-3">
          <h2 className="text-2xl sm:text-3xl font-bold text-white">
            Why photo tracking matters
          </h2>
          <p className="text-gray-300 text-base sm:text-lg">
            Job site photos end up in text threads, personal phones, and random cloud
            folders. When you need proof of what was done and when, that is a problem.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {sellingPoints.map(({ title, description }) => (
            <div key={title} className="space-y-3 text-center md:text-left">
              <div className="mx-auto md:mx-0 h-0.5 w-10 bg-blue-400/80" />
              <h3 className="text-xl font-semibold text-white">{title}</h3>
              <p className="text-gray-300 leading-relaxed">{description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-white/10 pt-16 sm:pt-20 space-y-10">
        <div className="text-center max-w-2xl mx-auto space-y-3">
          <h2 className="text-2xl sm:text-3xl font-bold text-white">
            Simple to use
          </h2>
          <p className="text-gray-300 text-base sm:text-lg">
            Upload, organize, find. That is the whole product. No setup calls, no
            per-seat fees.
          </p>
        </div>

        <ol className="relative grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-0">
          <div
            aria-hidden
            className="pointer-events-none absolute left-[16.66%] right-[16.66%] top-4 hidden h-px bg-white/15 md:block"
          />
          {steps.map(({ number, title, description }) => (
            <li
              key={title}
              className="relative flex flex-col items-center text-center space-y-3 px-4"
            >
              <span className="relative z-10 bg-gray-900 px-3 text-sm font-semibold tracking-[0.2em] text-blue-200">
                {number}
              </span>
              <h3 className="text-xl font-semibold text-white">{title}</h3>
              <p className="max-w-[16rem] text-gray-400 leading-relaxed text-sm sm:text-base">
                {description}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
};
